import { useEffect } from 'react';
import { toast } from 'sonner';

/**
 * Click a toast (not its buttons) to dismiss the strip — keeps feedback out of the way.
 */
export function ToastClickToDismiss() {
  useEffect(() => {
    const onPointerDown = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const toastEl = target.closest('[data-sonner-toast]');
      if (!toastEl) return;
      if (target.closest('button, a, [data-button], [data-close-button]')) return;
      toast.dismiss();
    };

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, []);

  return null;
}
